export default __webpack_public_path__ + "static/inQUBE-3083a82239d83cb479e7f070d0991c42.png";